const API_URL = "https://livvium-backend-an42.onrender.com/api/v1";
// const API_URL = "http://localhost:3001/api/v1";
// const API_URL = "http://192.168.11.249:3001/api/v1";
export default API_URL;
